import React from 'react';

import { Row } from '../atoms/row';
import { LinkComponent } from '../atoms/link-component';

import { Inspect as InspectComp } from '../templates/inspect';

const InspectWallbox = () => {
  return (
    <>
      <h1>Inspect Wallbox</h1>

      <Row gap={1}>
        <LinkComponent to="/inspect">Home</LinkComponent>
        <LinkComponent to="/inspect/inverter">Inverter</LinkComponent>
        <LinkComponent to="/inspect/wallbox">Wallbox</LinkComponent>
        <LinkComponent to="/inspect/heat-pump">Heat pump</LinkComponent>
        <LinkComponent to="/inspect/mqtt">MQTT</LinkComponent>
        <LinkComponent to="/inspect/plugs">Plugs</LinkComponent>
        <LinkComponent to="/inspect/plc">PLC</LinkComponent>
      </Row>

      <InspectComp
        variableIds={[
          'WB_TYPE',
          'WB_IP_ADRESS',
          'WB_IP_PORT',
          'WB_CLIENT_ID',
          'WB_INSTALL',
          'WB_ON',
          'WB_com_ok',
          'WB_cnt_com_ok',
          'WB_cnt_com_err',
          'WB_cnt_com_write',
          'WB_STATE',
          'WB_ACTUAL_POWER',
          'WB_MAX_DYNAMIC_CURRENT',
          'WB_MAX_CURRENT',
          'WB_WALLBOX_READY_COUNT',
          'WB_WALLBOX_CONNECTED_COUNT',
          'WB_WAIT',
          'WALLBOX_CONFIG',
          'WALLBOX_STATS',
          'WALLBOX_STATS_PERSISTED',
          'WB_ACTUAL_POWER_TOTAL',
          'WB_ENERGY_CONSUMPTION_TOTAL',
          'STATS_WB_ENERGY_CONSUMPTION_YEAR',
          'STATS_WB_ENERGY_CONSUMPTION_TODAY',
          'NEW_WB_ENERGY_CONSUMPTION_TOTAL',
          'WB_MODE_PV',
          'WB_MODE_SPOT',
          'WB_MODE_AUTO',
          'WB_MIN_CHARGE_ENERGY',
          'WB_MODE_NONE',
          'WB_SPOT_MI_STOP',
          'WB_SPOT_HI_STOP',
          'WB_TIME_OF_DISCONNECT',
          'WB_INFO',
          'WALLBOX_WAIT',
          'RFID_READER_STATS',
          'WALLBOX_AUTHORIZATION',
        ]}
      />
    </>
  );
};

export default InspectWallbox;
